import { pageHead } from "@app/framework/meta";
import { FinancialInformationPage } from "@modules/financial-information/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function FinancialInformation() {
  useLoaderData();

  return <FinancialInformationPage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("financialInformation"),
    appendAppName: true,
  });
};
